module.exports = __webpack_public_path__ + "img/1506020314.2735cff3.jpg";